import _merge from 'lodash-es/merge';
import { $$ } from './utils/querySelector';

const DEFAULT_OPTIONS = {
    wrapperElement: 'span',
    wrapperClass: 'unset-text-transform-uppercase',
    keywords: {
        badenova: /badenova/gi,
        'Super Sparrow': /Super.Sparrow/gi,
        'e.V.': /e\.v\./gi,
        'e. V.': /e\. v\./gi,
    },
    textContainerSelectors: [
        'main h1, main h2, main h3, main h5',
        '.ghwp-stage__title',
        '.horizontal-tabs ul li a',
        '.ghwp-header__menu a, .ghwp-header__menu button',
        '.hmapsprem_cat_tab',
        '.ghwp-accordion__item-title-text',
        '.ghwp-image-cards__title',
        '.ghwp-image-card__overlay-title',
        '.fwtm-race-category-card__art-title',
        '.ghwp-post-card__title',
        '.button, .button span',
    ],
};

export class TextWrapper {
    constructor(userOptions = {}) {
        this.options = {};
        this.parseOptions(userOptions);
        this.init();
    }

    init() {
        // merge container selectors
        const textContainers = $$()(
            this.options.textContainerSelectors.join(', ')
        );

        // Bypass elements that has other elements inside it to avoid
        // messing with attached events. It may be improved to use recursion.
        const textOnlyNodes = Array.from(textContainers).filter(
            (container) => !container.childElementCount
        );

        // Generate replacement map
        this.replacementMap = Object.keys(this.options.keywords).map(
            (keyword) => ({
                keyword,
                regex: this.options.keywords[keyword],
                replacement: this.wrap(keyword),
            })
        );

        // replace keywords with wrapped ones
        this.replacementMap.forEach((keyword) => {
            textOnlyNodes.forEach((node) => {
                if (keyword.regex.test(node.innerHTML)) {
                    node.innerHTML = node.innerHTML.replaceAll(
                        keyword.regex,
                        keyword.replacement
                    );
                }
            });
        });
    }

    wrap(text) {
        const wrapperEl = this.options.wrapperElement || 'span';
        const wrapperClass = this.options.wrapperClass || '';
        return `<${wrapperEl} class="${wrapperClass}">${text}</${wrapperEl}>`;
    }

    parseOptions(userOptions) {
        this.options = _merge(DEFAULT_OPTIONS, userOptions);
    }
}
